//TODO: t function does not work dynamically when switching languages
import { getCurrentDateYMD } from "./DateHelper";

const AXIOS_INSTANCE_CONFIG = Object.freeze({
    baseURL: process.env.REACT_APP_API_URL,
    timeout: 500000,
    validateStatus: false,
});

const AXIOS_MOCK_INSTANCE_CONFIG = Object.freeze({
    baseURL: process.env.REACT_APP_MOCK_API_URL,
    timeout: 500000,
    validateStatus: false,
});

const THRESHOLD_EMPTY_STATE = Object.freeze({
    target: "",
    compare: "",
    value: "",
    unit: "",
});

const LOGIC_TYPE = Object.freeze({
    and: "and",
    or: "or",
});

const THRESHOLD_START_STATE = Object.freeze({
    type: LOGIC_TYPE.and,
    filters: Object.freeze([THRESHOLD_EMPTY_STATE, THRESHOLD_EMPTY_STATE]),
});

const AXIOS_ALLIGATOR_INSTANCE_CONFIG = Object.freeze({
    baseURL: process.env.REACT_APP_ALLIGATOR_API_URL,
    timeout: 500000,
    validateStatus: false,
});

const AXIOS_BUCHI_WEBSERVICE_INSTANCE_CONFIG = Object.freeze({
    baseURL: process.env.REACT_APP_BUCHI_WEBSERVICE_API_URL,
    timeout: 500000,
    validateStatus: false,
});

const ORGANIZATION_PREFERENCES = Object.freeze({
    Lot: {
        label: "Lot",
        value: "Lot",
    },
});

const PREFERENCE_EMPTY_STATE = Object.freeze({
    entity: null,
    localizations: { en: "" },
});

const ROLES = Object.freeze({
    admin: "Admin",
    partnerAdmin: "PartnerAdmin",
    superAdmin: "SuperAdmin",
    user: "User",
    partnerUser: "PartnerUser",
    support: "Support",
});

const ROLES_VERSE = Object.freeze({
    Admin: "User",
    PartnerAdmin: "PartnerUser",
    User: "Admin",
    PartnerUser: "PartnerAdmin",
});

const MODEL_ACCESS = Object.freeze({
    owner: "Owner",
    read: "Read",
    write: "Write",
});

const MODEL_TYPE = Object.freeze({
    standard: "Standard",
    custom: "Custom",
});

const MODEL_PARAMETER_TYPE = Object.freeze({
    eigenvector: "Eigenvector",
    standard: "Standard",
    external: "External",
    calculatedFields: "CalculatedFields",
});

const MODEL_STATUS = Object.freeze({
    deployed: "Deployed",
    inProgress: "In Progress",
    completed: "Completed",
    notDeployed: "Not Deployed",
});

const ACCESS_OPTIONS = Object.freeze({
    read: { label: "read", value: "Read" },
    write: {
        label: "readWrite",
        value: "Read/Write",
    },
});

const NO_GROUP = Object.freeze({
    id: "bb0ec5b4-dafc-4c73-8a2a-08efd59feb7b",
});

const MEASUREMENT_METADATA = Object.freeze({
    sampleName: "sampleName",
    createdAt: "createdAt",
    scanner: "scanner",
    createdBy: "createdBy",
});

const SCANS_METADATA = Object.freeze({
    capturedAt: "capturedAt",
    scanner: "scanner",
    modelName: "modelName",
    createdBy: "createdBy",
    onBehalfOf: "onBehalfOf",
    lot: "lot",
});

const LABLAKE_SCANS_METADATA = Object.freeze({
    capturedAt: "capturedAt",
    instrumentId: "instrumentId",
    createdBy: "createdBy",
});

const DATE_FILTER_TYPE = Object.freeze({
    equal: "equal",
    inRange: "inRange",
    greaterThan: "greaterThan",
    lessThan: "lessThan",
});

const COMPARE_FILTER_TYPE = Object.freeze({
    equals: "equals",
    greaterThan: "greaterThan",
    lessThan: "lessThan",
    greaterThanOrEqual: "greaterThanOrEqual",
    lessThanOrEqual: "lessThanOrEqual",
});

const COMPARE_FILTER_TYPE_SIGN = Object.freeze({
    equals: "=",
    greaterThan: ">",
    lessThan: "<",
    greaterThanOrEqual: ">=",
    lessThanOrEqual: "<=",
});

const FILTER_TYPES = Object.freeze({
    text: "text",
    date: "date",
    compare: "compare",
    select: "select",
    number: "number",
    radio: "radio",
});

const TEXT_FILTER_TYPE = Object.freeze({
    equals: "equals",
    contains: "contains",
});

const METADATA_COLUMNS = Object.freeze({
    capturedAt: "Captured At",
    scanner: "Device Id",
    modelName: "Model Name",
    instrumentId: "Instrument Id",
    createdBy: "Created By",
    onBehalfOf: "On Behalf Of",
    lot: "Lot Name",
});

const METADATA_DATE_COLUMNS = Object.freeze(["capturedAt"]);

const COLLECT_METADATA_COLUMNS = Object.freeze({
    createdAt: "Created At",
    scanner: "Device Id",
    scannerId: "Device Id",
    createdBy: "Created By",
});

const DATES_CONSTANTS = Object.freeze({
    startDate: "startDate",
    endDate: "endDate",
});

const HTTP_METHODS = Object.freeze({
    get: "GET",
    post: "POST",
    put: "PUT",
    delete: "DELETE",
});

const ACTION_TYPE = Object.freeze({
    create: "Create",
    update: "Update",
    delete: "Delete",
    api: "API",
    error: "Error",
    mobile: "Mobile",
    other: "Other",
    integration: "Integration",
    get: "Get",
});

const ENTITY_TYPE = Object.freeze({
    model: "Model",
    publsihedModel: "Published Model",
    publsihedModelComment: "Published Model Comment",
    modelParameter: "Model Parameter",
    user: "User",
    organization: "Organization",
    wavenumber: "Wavenumber",
    settings: "Settings",
    storeAccess: "Store Access",
    productSubscription: "Product Subscription",
    productSubscriptionMaterial: "Product Subscription Material",
    favoriteProduct: "Favorite Product",
    product: "Product",
    productVersion: "Product Version",
    scanner: "Scanner",
    scannerTestResult: "Scanner Test Result",
    scan: "Scan",
    prediction: "Prediction",
    organizationIndustry: "Organization Industry",
    productVersionIndustry: "Product Version Industry",
    productVersionTag: "Product Version Tag",
    productVersionImage: "Product Version Image",
    productVersionSupportedCountry: "Product Version Supproted Country",
    productVersionSupportedAccessory: "Product Version Supported Accessory",
    productVersionScannerType: "Product Version Scanner Type",
    bundleProduct: "Bundle Product",
    modelParameterVersion: "Model Parameter Version",
    modelInfo: "Model Info",
    modelUserAccess: "Model User Access",
    subscriptionUserAccess: "Subscription User Access",
    modelOrganizationAccess: "Model Organization Access",
    modelMeasurement: "Model Measurement",
    modelScanMeasurement: "Model Scan Measurement",
    measurement: "Measurement",
    neoScan: "NeoScan",
    neoCollect: "NeoCollect",
    material: "Material",
    materialGroup: "Material Group",
    industry: "Industry",
    tag: "Industry",
    supportedAccessory: "Supported Accessory",
    biasCorrection: "Bias Correction",
    subscriptionBiasCorrection: "Subscription Bias Correction",
    subscriptionDisplayUnit: "Subscription Display Unit",
    supportedCountry: "Supported Country",
    lot: "Lot",
    unknown: "Unknown",
    external: "External",
    support: "Support",
    dataRobot: "DataRobot",
    shopify: "Shopify",
    integrationQueue: "Integration Queue",
    upgradeQueue: "Upgrade Queue",
    scanApp: "Scan App",
    subscriptionPlan: "Subscription Plan",
    modelParameterProductVersion: "Model Parameter Product Version",
    modelSupportedAccessory: "Model Supported Accessory",
    modelSupportedDevice: "Model Supported Device",
    webhook: "Webhook",
    supplier: "Supplier",
    materialSupplier: "Material Supplier",
    supplierSupportedCountry: "Supplier Supported Country",
    modelParameterUnit: "Model Parameter Unit",
    unit: "Unit",
    unitConversion: "Unit Conversion",
    coupon: "Coupon",
    promotionCode: "Promotion Code",
    couponProductParameter: "Coupon Product Parameter",
    classifier: "Classifier",
    classifierLabel: "Classifier Label",
    userOrganization: "User Organization",
    licensePlan: "License Plan",
    licensePlanPrice: "License Plan Price",
    organizationLicense: "Organization License",
    organizationStoreAccess: "Organization Store Access",
    scanFilter: "Scan Filter",
    rolePermission: "Role Permission",
    role: "Role",
    permission: "Permission",
    permissionCategory: "Permission Category",
    permissionCategoryPermission: "Permission Category Permission",
    alert: "Alert",
    modelTransfer: "Model Transfer",
    apiKey: "Api Key",
    shipment: "Shipment",
    legalSetting: "Legal Setting",
    notificationEvent: "Notification Event",
    tileCompensation: "Tile Compensation",
    autoMeasurementConfiguration: "Auto Measurement Configuration",
    convertMeasurementTask: "Convert Measurement Task",
    instrument: "Instrument",
    instrumentSTD: "Instrument STD",
    instrumentOrganizationAccess: "Instrument Organization Access",
    instrumentUserAccess: "Instrument User Access",
    labLakeMaterial: "Lab Lake Material",
    labLakeMaterialVersion: "Lab Lake Material Version",
    labLakeMaterialVersionParameter: "Lab Lake Material Version Parameter",
    labLakeMaterialVersionInstrumentAccess:
        "Lab Lake Material Version Instrument Access",
    labLakeScan: "Lab Lake Scan",
    labLakeScanPrediction: "Lab Lake Scan Prediction",
    labLakeWebhook: "Lab Lake Webhook",
});

const SUBSCRIPTION_TYPES = Object.freeze({
    monthly: "Monthly",
    annual: "Annual",
    trial: "Trial",
    custom: "Custom",
});

const CURRENCY_NAMES = Object.freeze({
    dollar: "Dollar",
    euro: "Euro",
});

const CURRENCY = Object.freeze({
    dollar: "USD",
    euro: "EUR",
});

const PRODUCT_TYPES = Object.freeze({
    model: "Model",
    bundle: "Bundle",
    single: "Single",
});

const MODEL_SCOPE = Object.freeze({
    global: "Global",
    local: "Local",
});

const SPECTRAL_TYPE = Object.freeze({
    readings: "readings",
    average: "average",
});

const LABLAKE_SPECTRAL_TYPE = Object.freeze({
    standardized: "standardized",
    raw: "raw",
});

const COUPON_TYPES = Object.freeze({
    0: "Added Parameter",
    1: "Discount and Parameters",
    2: "Discount",
});

const REFERENCE_MODEL_OPTIONS = Object.freeze({
    All: 0,
    LinkedModels: 1,
    ReferenceModels: 2,
});

const ANSWERS = Object.freeze({
    yes: "Yes",
    no: "No",
});

const TRIAL_DAYS = Object.freeze({
    7: { label: "7", value: 7 },
    14: { label: "14", value: 14 },
    30: { label: "30", value: 30 },
});

const BOOLEAN_OPTIONS = Object.freeze({
    true: "true",
    false: "false",
});

const BOOLEAN_DROPDOWN = Object.freeze({
    true: { label: "true", name: "True", value: true, booleanValue: true },
    false: {
        label: "false",
        name: "False",
        value: false,
        booleanValue: false,
    },
});

const SORTING_DIRECTION_OPTIONS = Object.freeze({
    ASC: { name: "ASC", label: "ASC", value: "ASC" },
    DESC: { name: "DESC", label: "DESC", value: "DESC" },
});

const STATUS_OPTIONS = Object.freeze({
    active: "Active",
    unpaid: "Unpaid",
    canceled: "Canceled",
    expired: "Expired",
});

const COLOR_PICKER_DEFAULTS = Object.freeze([
    "#3d4871",
    "#D9E3F0",
    "#F47373",
    "#697689",
    "#2CCCE4",
    "#555555",
    "#dce775",
    "#ff8a65",
]);

const GLOBAL_ID = 251;

const SPECTRUM_POINTS_BOUNDARY = 1500;

const SENTRY_URL = Object.freeze({
    dev: "https://7ff0b9fa2cd94de980efcfe2cf197f1a@o1011020.ingest.sentry.io/6153757",
    test: "https://7ff0b9fa2cd94de980efcfe2cf197f1a@o1011020.ingest.sentry.io/6153757",
    prod: "https://fb9b00bd69af4df4b26000f05385940d@o1011020.ingest.sentry.io/6158671",
});

const LABSTORE_ACCESS = Object.freeze({
    view: "Viewer",
    subscribe: "Subscriber",
    publish: "Publisher",
});
const LABSTORE_ACCESS_VIEW = Object.freeze({
    new: "New",
    old: "Old",
});

const PRODUCTS_STATUS = Object.freeze({
    accepted: "Accepted",
    rejected: "Rejected",
    deprecated: "Deprecated",
    underReview: "Under Review",
});

const TAGS_CLASSNAMES = Object.freeze({
    completed: "tag-completed",
    declined: "tag-declined",
    inProgress: "tag-in progress",
    undeployed: "tag-undeployed",
    deployed: "tag-deployed",
    bundle: "tag-bundle",
    unknown: "Unknown",
    trueCheck: "fas fa-check-circle",
    falseCheck: "fas fa-times-circle",
});

const URL_SCOPES = Object.freeze({
    lablake: "lablake",
});

const API_VERSIONS = Object.freeze({
    v1: "v1",
    v2: "v2",
});

const LANGUAGE = Object.freeze({
    English: "en",
    Portuguese: "pt",
    Spanish: "es",
    Chinese: "zh",
    Polish: "pl",
    Turkish: "tr",
    German: "de",
    French: "fr",
});

const UUIDS = Object.freeze({
    defaultScannerId: "8ae0f8e2-4779-429c-ac23-03b62c16bd02",
    aunirId: "ebb28465-59da-4d0c-9f51-aacb214802fb",
});

const UNITS = Object.freeze({
    percentage: { label: "%", value: 1 },
    empty_unit: { label: "None", value: 23 },
});

const MODEL_PROCESSING_TYPES = Object.freeze({
    Regression: {
        label: "Regression",
        value: "Regression",
    },
    Classification: {
        label: "Classification",
        value: "Classification",
    },
});

const LANGUAGE_FLAG_DATA = {
    en: { flag: "us", language: "English" },
    es: { flag: "es", language: "Spanish" },
    pt: { flag: "pt", language: "Portuguese" },
    zh: { flag: "cn", language: "Chinese" },
};

const DATA_TYPES = {
    number: "number",
    string: "string",
    object: "object",
    boolean: "boolean",
};

const FIELD_TYPES = Object.freeze({
    GridTextFields: "GridTextFields",
    TextArea: "TextArea",
    TextBox: "TextBox",
    Switch: "Switch",
    File: "File",
    Date: "Date",
    DateTime: "DateTime",
    Input: "Input",
    Dropdown: "Dropdown",
    RadioButton: "RadioButton",
    Compare: "Compare",
    EquationBuilder: "EquationBuilder",
    DoubleInput: "DoubleInput",
    Text: "text",
    CheckBoxes: "checkBoxes",
    CheckBox: "checkBox",
    Element: "element",
    Enum: "enum",
    Number: "number",
});

const OUTLIER_APPROACH = Object.freeze({
    t2AndQresidual: {
        label: "Reduced Hotelling T2 & Q-Residual",
        value: "t2AndQresidual",
    },
    mahalanobis: {
        label: "Mahalanobis",
        value: "mahalanobis",
    },
});

const OUTLIER_TYPES = Object.freeze({
    qresidual: { label: "Q-Residual", value: "QResidual" },
    reducedhotellingt2: {
        label: "Reduced Hotelling T2",
        value: "ReducedHotellingT2",
    },
});

const IMAGE_MAP = Object.freeze({
    users: "no-avatar.png",
    Suppliers: "org-avatar.png",
    lots: "location.png",
    affiliates: "org-avatar.png",
    subscriptions: "neural.png",
    userAccess: "neural.png",
    lablakeMaterials: "material.png",
    lablakeMaterialVersions: "neural.png",
});

const SUBSCRIPTION_PRODUCT_TYPES = Object.freeze({
    license: "license",
    product: "product",
});

const AXIS_TYPES = Object.freeze({ X_AXIS: "xAxis", Y_AXIS: "yAxis" });

const X_AXIS_TYPES = Object.freeze({
    waveNumber: "wavenumber",
    waveLength: "wavelength",
});
const Y_AXIS_TYPES = Object.freeze({
    reflectance: "reflectance",
    absorbance: "absorbance",
});

const EXPORT_FORMATS = Object.freeze({
    csv: "csv",
    nir: "nir",
    pdf: "pdf",
    xml: "xml",
    xlsx: "xlsx",
});

const NOTIFICATION_TYPES = Object.freeze({
    email: "Email",
    system: "SystemNotification",
});

const ICON_TYPES = {
    warn: "exclamation-circle",
    warnTriangle: "exclamation-triangle",
    info: "info-circle",
    error: "exclamation-circle",
};

const PARAMETER_CONSTRAINTS_OPERATIONS = Object.freeze({
    min: "Min",
    max: "Max",
    eq: "Eq",
});

const NULL_OPTION = Object.freeze({ label: "--", value: null });

const MAX_UNITS_PER_PARAMETER = 10;
const MAX_PARAMETER = 40;

const MAX_LABELS_PER_CLASSIFIER = 10;
const MIN_LABELS_PER_CLASSIFIER = 2;

const EQUATION_CONSTANTS = Object.freeze({
    emptySpace: " ",
    openBracket: "(",
    closingBracket: ")",
    plus: "+",
    minus: "-",
    multiply: "*",
    divide: "/",
    comma: ",",
    left: "Left",
    right: "Right",
    function: "function",
    sign: "sign",
    binary: "binary",
});

const OPERATIONS_TYPE = Object.freeze({
    OPERATION: "arithmeticOperation",
    VARIABLE: "variable",
    CONSTANT: "constant",
    UNKNOWN: "unknown",
    OPEN_BRACKETS: "openBracket",
    CLOSE_BRACKETS: "closedBracket",
    INVALID: "invalid",
    FUNCTION: "function",
    MATH_SYMBOLS: "mathSymbols",
    GROUP: "group",
});

const SCANS_FILTER_OPTIONS = Object.freeze([
    {
        label: "materialName",
        name: "materialName",
        type: "Input",
        placeholder: "materialNamePlaceholder",
    },
    {
        label: "capturedAt",
        name: "createdAt",
        type: "Date",
        max: getCurrentDateYMD(),
    },
]);

const MEASUREMENTS_FILTER_OPTIONS = Object.freeze([
    {
        label: "materialName",
        name: "materialName",
        type: "Input",
        placeholder: "materialNamePlaceholder",
    },
    {
        label: "createdAt",
        name: "createdAt",
        type: "Date",
        max: getCurrentDateYMD(),
    },
]);

const FIREBASE_TYPES = Object.freeze({
    modelTransfer: "Model Transfer",
    prediction: "Prediction",
});

const NOTIFICATION_EVENT_TYPES = Object.freeze({
    release: "release",
    // whatsNew: "whatsNew",
});

const TARGET_APPLICATIONS = Object.freeze({
    scan_iOS: "scan_iOS",
    scan_android: "scan_android",
    // collect_iOS: "collect_iOS",
    // collect_android: "collect_android",
    // collect_desktop: "collect_desktop",
});

const PARAMETER_TYPES = Object.freeze({
    0: "Regression",
    1: "Classification",
});

const PREDICTION_STATUS = Object.freeze({
    0: "active",
    1: "deprecated",
});

const ACTIVE_STATUS_SELECT_OPTIONS = Object.freeze([
    { label: "Active", value: "ACTIVE" },
    { label: "Inactive", value: "INACTIVE" },
]);

const ORGANIZATION_TYPES = Object.freeze({
    Lab: "Lab",
    Enterprise: "Enterprise",
    Farm: "Farm",
    Consultant: "Consultant",
    Feedmill: "Feedmill",
    Others: "Others",
});

const MeasurementConversionConfigsStatus = Object.freeze({
    0: "onHold",
    1: "running",
    2: "inactive",
});

const MEASUREMENT_TYPES = Object.freeze({
    Scan: "scan",
    Collcet: "collect",
});

const INSTRUMENTS = Object.freeze({
    fossBlueSun: "Foss/BlueSun",
});

const FILES_EXTENSIONS = Object.freeze({
    cal: "cal",
    nad: "nad",
    eqa: "eqa",
    pca: "pca",
    lib: "lib",
    std: "std",
    nax: "nax",
});

const INSTRUMENTS_TYPES = Object.freeze(
    Object.values(INSTRUMENTS).map((instrument) => ({
        label: instrument,
        value: instrument,
    }))
);

const API_KEY_STATUS = Object.freeze(
    ["New", "Active", "Revoked", "Expired"].map((status) => ({
        label: status,
        value: status.toLowerCase(),
    }))
);

const EXPORT_OPTIONS = Object.freeze({
    CSV: "csv",
    XLSX: "xlsx",
    MeasurementsCSV: "measurementsCSV",
    MeasurementsXLSX: "measurementsXLSX",
    NIR: "nir",
    XML: "xml",
    Eigenvector: "eigenvector",
    EigenvectorCSV: "eigenvectorCSV",
    EigenvectorXLSX: "eigenvectorXLSX",
});

const EXTENSIONS_CONTENT_TYPE = Object.freeze({
    ".tsv": "text/tab-separated-values",
    ".nir": "application/octet-stream",
    ".cal": "application/octet-stream",
    ".nax": "application/zip",
});

const FREQUENCY_OF_BACKGROUNDS_LOOKUP = Object.freeze([
    { label: "once", value: "once" },
    { label: "withEverySample", value: "withEverySample" },
    {
        label: "afterCertainNumberOfSamples",
        value: "afterCertainNumberOfSamples",
    },
]);

const GB_SIZE = 1024;

const TESTING_PROMOTION_CODES = ["NEOSALES100", "VALENVERAS100"];

const BASE_ASSETS_URL = `${process.env.REACT_APP_STATIC_ASSETS_CDN}/${process.env.REACT_APP_NODE_ENV}`;

const FLAGS = Object.freeze({
    china: `${BASE_ASSETS_URL}/flags/china.png`,
    korea: `${BASE_ASSETS_URL}/flags/korea.png`,
    poland: `${BASE_ASSETS_URL}/flags/poland.png`,
    portugal: `${BASE_ASSETS_URL}/flags/portugal.png`,
    spain: `${BASE_ASSETS_URL}/flags/spain.png`,
    states: `${BASE_ASSETS_URL}/flags/states.png`,
    turkey: `${BASE_ASSETS_URL}/flags/turkey.png`,
    germany: `${BASE_ASSETS_URL}/flags/germany.png`,
    france: `${BASE_ASSETS_URL}/flags/france.png`,
});

export {
    AXIOS_INSTANCE_CONFIG,
    AXIOS_MOCK_INSTANCE_CONFIG,
    EQUATION_CONSTANTS,
    ORGANIZATION_PREFERENCES,
    ROLES,
    ROLES_VERSE,
    NO_GROUP,
    MODEL_ACCESS,
    MEASUREMENT_METADATA,
    DATE_FILTER_TYPE,
    COMPARE_FILTER_TYPE,
    FILTER_TYPES,
    TEXT_FILTER_TYPE,
    METADATA_COLUMNS,
    METADATA_DATE_COLUMNS,
    COLLECT_METADATA_COLUMNS,
    DATES_CONSTANTS,
    SCANS_METADATA,
    HTTP_METHODS,
    ACTION_TYPE,
    GB_SIZE,
    ENTITY_TYPE,
    SPECTRAL_TYPE,
    LABLAKE_SPECTRAL_TYPE,
    ACCESS_OPTIONS,
    MODEL_STATUS,
    SPECTRUM_POINTS_BOUNDARY,
    SENTRY_URL,
    SUBSCRIPTION_TYPES,
    COMPARE_FILTER_TYPE_SIGN,
    CURRENCY_NAMES,
    CURRENCY,
    PRODUCT_TYPES,
    MODEL_SCOPE,
    COUPON_TYPES,
    ANSWERS,
    TRIAL_DAYS,
    COLOR_PICKER_DEFAULTS,
    LABSTORE_ACCESS,
    GLOBAL_ID,
    PRODUCTS_STATUS,
    TAGS_CLASSNAMES,
    API_VERSIONS,
    BOOLEAN_OPTIONS,
    BOOLEAN_DROPDOWN,
    MODEL_PARAMETER_TYPE,
    STATUS_OPTIONS,
    LANGUAGE,
    UUIDS,
    UNITS,
    MAX_UNITS_PER_PARAMETER,
    MAX_PARAMETER,
    MODEL_PROCESSING_TYPES,
    LANGUAGE_FLAG_DATA,
    MAX_LABELS_PER_CLASSIFIER,
    MIN_LABELS_PER_CLASSIFIER,
    FIELD_TYPES,
    DATA_TYPES,
    IMAGE_MAP,
    SUBSCRIPTION_PRODUCT_TYPES,
    OUTLIER_TYPES,
    LOGIC_TYPE,
    AXIS_TYPES,
    X_AXIS_TYPES,
    Y_AXIS_TYPES,
    NOTIFICATION_TYPES,
    NULL_OPTION,
    EXPORT_FORMATS,
    OPERATIONS_TYPE,
    ICON_TYPES,
    PREFERENCE_EMPTY_STATE,
    PARAMETER_CONSTRAINTS_OPERATIONS,
    SORTING_DIRECTION_OPTIONS,
    SCANS_FILTER_OPTIONS,
    MEASUREMENTS_FILTER_OPTIONS,
    FIREBASE_TYPES,
    PARAMETER_TYPES,
    PREDICTION_STATUS,
    ORGANIZATION_TYPES,
    MODEL_TYPE,
    NOTIFICATION_EVENT_TYPES,
    TARGET_APPLICATIONS,
    MeasurementConversionConfigsStatus,
    MEASUREMENT_TYPES,
    INSTRUMENTS,
    INSTRUMENTS_TYPES,
    API_KEY_STATUS,
    URL_SCOPES,
    AXIOS_ALLIGATOR_INSTANCE_CONFIG,
    AXIOS_BUCHI_WEBSERVICE_INSTANCE_CONFIG,
    EXPORT_OPTIONS,
    LABLAKE_SCANS_METADATA,
    THRESHOLD_EMPTY_STATE,
    THRESHOLD_START_STATE,
    FILES_EXTENSIONS,
    EXTENSIONS_CONTENT_TYPE,
    REFERENCE_MODEL_OPTIONS,
    OUTLIER_APPROACH,
    FREQUENCY_OF_BACKGROUNDS_LOOKUP,
    ACTIVE_STATUS_SELECT_OPTIONS,
    TESTING_PROMOTION_CODES,
    LABSTORE_ACCESS_VIEW,
    FLAGS,
};
